import React from "react";
// import Button from "react-bootstrap/Button";
// import Col from "react-bootstrap/Col";
// import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
// import "../styles/Contact.css";
function Contact() {
  return (
    <div className="bg-[#9ceaef] h-screen flex place-content-center items-center md:pl-0 md:pr-0 pl-5 pr-5">
      <form name="contact" method="post" netlify>
        <input type="hidden" name="form-name" value="contact" />
        <label htmlFor="name" className="block pb-2 ">
          Name
        </label>
        <input
          name="name"
          className="block w-full rounded-md p-1.5 pl-3 "
          type="text"
          placeholder="Enter your name"
          required
        />

        <div className="w-full pt-3 flex flex-wrap md:gap-3">
          <div className="md:w-fit w-full">
            <label htmlFor="mobileNo" className="block pb-2">
              Mobile No.
            </label>
            <input
              className="w-full rounded-md p-1.5 pl-3"
              name="mobileNo"
              type="tel"
              placeholder="+91 XXXXXXXXXX"
              required
            />
          </div>
          <div className="md:w-fit w-full">
            <label htmlFor="email" className="block pb-2">
              Email
            </label>
            <input
              className="w-full rounded-md p-1.5 pl-3"
              name="email"
              type="email"
              placeholder="Enter your email"
              required
            />
          </div>
        </div>
        <label htmlFor="subject" className="block pt-3 pb-2">
          Subject
        </label>
        <input
          className="block w-full rounded-md p-1.5 pl-3"
          name="subject"
          type="text"
          placeholder="Write subject"
          required
        />

        <label className="block pt-3 pb-2" htmlFor="message">
          Message
        </label>
        <textarea
          className="w-full rounded-md p-1.5 pl-3"
          name="message"
          type="text"
          placeholder="Write your message"
          required
        />
        <button
          className="rounded-lg bg-blue-500 hover:bg-blue-700 text-white p-2 pl-4 pr-4 my-3"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default Contact;
